const valueIsNonEmptyString = (value) => {
  if (!value) return false;

  const valueString = `${value}`.trim();
  if (!valueString || valueString.length <= 0) return false;

  return true;
};

export default valueIsNonEmptyString;
